import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely transforms CDN URLs using Cloudflare CDN image resizer options
 * avoiding double wrapping.
 */
export function getCdnImageUrl(url, width = 800, quality = 80) {
  if (!url || typeof url !== 'string') return '';
  
  // If already transformed with cdn-cgi/image, clean or return
  if (url.includes('/cdn-cgi/image/')) {
    // Extract base asset path after cdn-cgi/image/options/
    const parts = url.split('/assets/');
    if (parts.length > 1) {
      return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/assets/${parts[1]}`;
    }
    return url;
  }

  if (url.startsWith('https://assets.auxodev.dk/')) {
    const assetPath = url.replace('https://assets.auxodev.dk/', '');
    return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/${assetPath}`;
  }

  return url;
}
